












import { Vue, Prop, Component } from 'vue-property-decorator';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';

@Component({
  components: { VbTooltipSlot },
})
export default class IconInfoDescription extends Vue {
  @Prop({
    required: false,
    default: '',
  })
  description!: string;
}
